import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ContentModule} from "../../../../shared/directives/content.module";
import {ItemComponent, MoreButtonsDirective} from "./item.component";
import {ConfirmationButtonModule} from "../../../../components/common/button/confirmation-button/confirmation-button.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {ButtonModule} from "../button/button.module";
import {IconsModule} from "../../../../../icons.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ContentModule,
        ConfirmationButtonModule,
        LoadingModule,
        ButtonModule,
        IconsModule,
    ],
    declarations: [
        ItemComponent,
        MoreButtonsDirective
    ],
    exports: [ItemComponent, MoreButtonsDirective]
})
export class ItemModule {}